/**
 * PULSE Bundle Size Picker
 * ------------------------------------------------------------
 * Intercepts Add clicks on bundles that carry a bundle size
 * (data-bundle-size on the button). Customer chooses their
 * Short/Long split, capped at the bundle total, and the mix is
 * saved as cart line item properties so it reaches the order.
 *
 * Works from the product page upsell cards and the cart drawer.
 */
(function(){
  var overlay = document.getElementById('MixOverlay');
  if(!overlay) return;

  var modal = overlay.querySelector('.mix-modal');
  var closeBtn = document.getElementById('MixClose');
  var confirmBtn = document.getElementById('MixConfirm');
  var headingEl = document.getElementById('MixHeading');
  var subtitleEl = document.getElementById('MixSubtitle');
  var selectedEl = document.getElementById('MixSelected');
  var totalEl = document.getElementById('MixTotal');
  var progressEl = document.getElementById('MixProgress');
  var hintEl = document.getElementById('MixHint');
  var quickEl = document.getElementById('MixQuick');

  var state = { size: 2, variantId: null, title: '', counts: { Short: 0, Long: 0 }, sourceBtn: null };

  function total(){ return state.counts.Short + state.counts.Long; }

  function renderQuickPicks(){
    if(!quickEl) return;
    var n = state.size;
    var picks = [];

    if(n === 2){
      picks = [
        { label: '1 + 1', Short: 1, Long: 1 },
        { label: '2 Short', Short: 2, Long: 0 },
        { label: '2 Long', Short: 0, Long: 2 }
      ];
    } else if(n === 5){
      picks = [
        { label: 'All Long', Short: 0, Long: 5 },
        { label: '2 + 3', Short: 2, Long: 3 },
        { label: 'All Short', Short: 5, Long: 0 }
      ];
    } else {
      picks = [
        { label: 'All Long', Short: 0, Long: n },
        { label: 'All Short', Short: n, Long: 0 }
      ];
    }

    quickEl.innerHTML = '<span class="mix-quick-label">Quick pick</span>' +
      picks.map(function(p){
        return '<button type="button" class="mix-quick-btn" data-short="' + p.Short + '" data-long="' + p.Long + '">' + p.label + '</button>';
      }).join('');
  }

  function update(){
    var t = total();
    var remaining = state.size - t;

    document.querySelectorAll('.mix-qty').forEach(function(el){
      el.textContent = state.counts[el.getAttribute('data-qty')];
    });

    if(selectedEl) selectedEl.textContent = t;
    if(totalEl) totalEl.textContent = state.size;
    if(progressEl) progressEl.style.width = Math.min(100, (t / state.size) * 100) + '%';

    // Disable + buttons once the bundle is full
    document.querySelectorAll('.mix-btn').forEach(function(btn){
      var step = parseInt(btn.getAttribute('data-step'), 10);
      var fit = btn.getAttribute('data-fit');
      if(step > 0){
        btn.disabled = remaining <= 0;
      } else {
        btn.disabled = state.counts[fit] <= 0;
      }
    });

    // Highlight a matching quick pick
    document.querySelectorAll('.mix-quick-btn').forEach(function(btn){
      var s = parseInt(btn.getAttribute('data-short'), 10);
      var l = parseInt(btn.getAttribute('data-long'), 10);
      btn.classList.toggle('is-active', s === state.counts.Short && l === state.counts.Long);
    });

    var complete = t === state.size;
    if(confirmBtn) confirmBtn.disabled = !complete;

    if(hintEl){
      if(complete){
        hintEl.textContent = state.counts.Short + ' Short \u00b7 ' + state.counts.Long + ' Long';
        hintEl.classList.add('is-complete');
      } else {
        hintEl.textContent = 'Choose ' + remaining + ' more ' + (remaining === 1 ? 'item' : 'items') + '.';
        hintEl.classList.remove('is-complete');
      }
    }
  }

  function open(btn){
    state.size = parseInt(btn.getAttribute('data-bundle-size'), 10) || 2;
    state.variantId = btn.getAttribute('data-variant-id');
    state.title = btn.getAttribute('data-bundle-title') || 'PULSE Bundle';
    state.counts = { Short: 0, Long: 0 };
    state.sourceBtn = btn;

    if(headingEl) headingEl.textContent = state.title;
    if(subtitleEl) subtitleEl.textContent = 'Choose your ' + state.size + ' pairs \u2014 any mix of Short and Long.';

    renderQuickPicks();
    update();

    overlay.hidden = false;
    // next frame so the transition runs
    requestAnimationFrame(function(){ overlay.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    if(closeBtn) closeBtn.focus();
  }

  function close(){
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function(){ overlay.hidden = true; }, 300);
    if(state.sourceBtn){
      state.sourceBtn.disabled = false;
      state.sourceBtn = null;
    }
  }

  if(closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e){ if(e.target === overlay) close(); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && !overlay.hidden) close();
  });

  // Steppers
  overlay.addEventListener('click', function(e){
    var stepBtn = e.target.closest('.mix-btn');
    if(stepBtn && !stepBtn.disabled){
      var fit = stepBtn.getAttribute('data-fit');
      var step = parseInt(stepBtn.getAttribute('data-step'), 10);
      var next = state.counts[fit] + step;
      if(next < 0) return;
      if(step > 0 && total() >= state.size) return;
      state.counts[fit] = next;
      update();
      return;
    }

    var quick = e.target.closest('.mix-quick-btn');
    if(quick){
      state.counts.Short = parseInt(quick.getAttribute('data-short'), 10);
      state.counts.Long = parseInt(quick.getAttribute('data-long'), 10);
      update();
    }
  });

  // Confirm — add with line item properties
  if(confirmBtn){
    confirmBtn.addEventListener('click', function(){
      if(total() !== state.size || !window.PulseCart) return;

      var props = {};
      if(state.counts.Short > 0) props['Short fit'] = state.counts.Short;
      if(state.counts.Long > 0) props['Long fit'] = state.counts.Long;

      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Adding\u2026';

      window.PulseCart.add(state.variantId, 1, props)
        .then(function(){
          confirmBtn.textContent = 'Added \u2713';
          setTimeout(function(){
            confirmBtn.textContent = 'Add to Bag';
            close();
            window.PulseCart.openDrawer();
          }, 600);
        })
        .catch(function(err){
          console.error('PULSE: bundle add failed', err);
          confirmBtn.textContent = 'Try again';
          confirmBtn.disabled = false;
        });
    });
  }

  // Intercept any Add button that declares a bundle size
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-bundle-size]');
    if(!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn);
  }, true); // capture phase, so it runs before the normal add-to-cart handler

})();
